import { render } from "./HeroiconsOutlineEye.vue?vue&type=template&id=fa08dc86"
const script = {}

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineEye.vue"]])

export default __exports__